// extracted by mini-css-extract-plugin
module.exports = {"costEst_container_box":"CostEstimation-module--costEst_container_box--1x1k5"};